// extracted by mini-css-extract-plugin
module.exports = {"Container":"Page_Container__bcq2n","DealList":"Page_DealList__jjUE9"};